import http from 'plugins/axios';

export default {
    getNewCoinPage(data) {
        return http.get({
            url: '/admin/mining/new/newCoinPage',
            data
        });
    },

    addOrUpdateNewCoin(data) {
        return http.post({
            url: '/admin/mining/new/newCoinAddOrUpdate',
            data
        });
    },

    updateNewCoinState(data) {
        return http.post({
            url: '/admin/mining/new/newCoinUpdateState',
            data,
            dataType: 'form'
        });
    },

    deleteNewCoin(data) {
        return http.get({
            url: '/admin/mining/new/newCoinDelete',
            data
        });
    },

    getNewCoinPoolPage(data) {
        return http.get({
            url: '/admin/mining/new/pool/newCoinPoolPage',
            data
        });
    },

    addOrUpdatePool(data) {
        return http.post({
            url: '/admin/mining/new/pool/addOrUpdate',
            data
        });
    },

    updatePoolState(data) {
        return http.post({
            url: '/admin/mining/new/pool/updateState',
            data,
            dataType: 'form'
        });
    },

    deletePool(data) {
        return http.get({
            url: '/admin/mining/new/pool/delete',
            data
        });
    },

    stopUsingPool(data) {
        return http.get({
            url: '/admin/mining/new/pool/stopUsing',
            data
        });
    },

    unlockPool(data) {
        return http.get({
            url: '/admin/mining/new/pool/unlock',
            data
        });
    },

    getNewCoinPoolDetailPage(data) {
        return http.get({
            url: '/admin/mining/new/poolDetail/newCoinPoolDetailPage',
            data
        });
    },

    addOrUpdatePoolDetail(data) {
        return http.post({
            url: '/admin/mining/new/poolDetail/addOrUpdate',
            data
        });
    },

    deletePoolDetail(data) {
        return http.get({
            url: '/admin/mining/new/poolDetail/delete',
            data
        });
    },

    getInComeCoinPage(data) {
        return http.get({
            url: '/admin/mining/new/inCome/inComeCoinPage',
            data
        });
    },

    inComeSupply(data) {
        return http.get({
            url: '/admin/mining/new/inCome/supply',
            data
        });
    },

    userRecordPage(data) {
        return http.get({
            url: '/admin/mining/new/userRecordPage',
            data
        });
    },

    getAllSupportCoin() {
        return http.get({
            url: '/admin/coin/allDisplay'
        });
    },
};
